/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Capture_DeniedInputs */

const th_video_capture_denied = /** @type {(inputs: Video_Capture_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่ได้รับอนุญาตให้บันทึกภาพ โปรดอนุญาตในเบราว์เซอร์แล้วเลือกแหล่งภาพอีกครั้ง`)
};

const en_video_capture_denied = /** @type {(inputs: Video_Capture_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capture was not allowed. Allow access in your browser, then choose a source again.`)
};

const ja_video_capture_denied = /** @type {(inputs: Video_Capture_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプチャが許可されませんでした。ブラウザーでアクセスを許可し、もう一度映像ソースを選んでください。`)
};

const zh_video_capture_denied = /** @type {(inputs: Video_Capture_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`采集未获允许。请在浏览器中允许访问，然后重新选择来源。`)
};

const es_video_capture_denied = /** @type {(inputs: Video_Capture_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se ha permitido la captura. Permite el acceso en tu navegador y vuelve a elegir una fuente.`)
};

const pt_video_capture_denied = /** @type {(inputs: Video_Capture_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A captura não foi permitida. Permita o acesso no navegador e escolha uma fonte de novo.`)
};

const id_video_capture_denied = /** @type {(inputs: Video_Capture_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perekaman tidak diizinkan. Izinkan akses di peramban lalu pilih sumber lagi.`)
};

const fr_video_capture_denied = /** @type {(inputs: Video_Capture_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La capture n’a pas été autorisée. Autorisez l’accès dans votre navigateur, puis choisissez à nouveau une source.`)
};

const tl_video_capture_denied = /** @type {(inputs: Video_Capture_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi pinayagan ang pagkuha. Payagan ang paggamit sa browser at pumili muli ng pinagkukunan.`)
};

const vi_video_capture_denied = /** @type {(inputs: Video_Capture_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Việc thu hình không được phép. Hãy cho phép truy cập trong trình duyệt rồi chọn lại nguồn.`)
};

const ko_video_capture_denied = /** @type {(inputs: Video_Capture_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`캡처가 허용되지 않았습니다. 브라우저에서 접근을 허용한 뒤 소스를 다시 고르세요.`)
};

const de_video_capture_denied = /** @type {(inputs: Video_Capture_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Aufnahme wurde nicht erlaubt. Erlaube den Zugriff im Browser und wähle dann erneut eine Quelle.`)
};

const ru_video_capture_denied = /** @type {(inputs: Video_Capture_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Захват не разрешён. Разрешите доступ в браузере и выберите источник заново.`)
};

const tr_video_capture_denied = /** @type {(inputs: Video_Capture_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yakalamaya izin verilmedi. Tarayıcıda erişime izin verip yeniden kaynak seçin.`)
};

const it_video_capture_denied = /** @type {(inputs: Video_Capture_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'acquisizione non è stata consentita. Consenti l'accesso nel browser e riseleziona una sorgente.`)
};

const pl_video_capture_denied = /** @type {(inputs: Video_Capture_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie zezwolono na przechwytywanie. Zezwól na dostęp w przeglądarce i wybierz źródło ponownie.`)
};

const uk_video_capture_denied = /** @type {(inputs: Video_Capture_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Захоплення не дозволено. Дозвольте доступ у браузері й оберіть джерело знову.`)
};

const hi_video_capture_denied = /** @type {(inputs: Video_Capture_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्चर की अनुमति नहीं मिली। ब्राउज़र में पहुँच दें और फिर स्रोत चुनें।`)
};

const ar_video_capture_denied = /** @type {(inputs: Video_Capture_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يُسمح بالالتقاط. اسمح بالوصول في المتصفح ثم اختر مصدرًا من جديد.`)
};

const ms_video_capture_denied = /** @type {(inputs: Video_Capture_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rakaman tidak dibenarkan. Benarkan akses dalam pelayar dan pilih sumber sekali lagi.`)
};

const bn_video_capture_denied = /** @type {(inputs: Video_Capture_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ধারণের অনুমতি মেলেনি। ব্রাউজারে অনুমতি দিয়ে আবার উৎস বেছে নিন।`)
};

const zh_tw2_video_capture_denied = /** @type {(inputs: Video_Capture_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未取得擷取權限。請在瀏覽器中允許存取，然後重新選擇來源。`)
};

const zh_hk2_video_capture_denied = /** @type {(inputs: Video_Capture_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未取得擷取權限。請在瀏覽器中允許存取，然後重新選擇來源。`)
};

const ur_video_capture_denied = /** @type {(inputs: Video_Capture_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ریکارڈنگ کی اجازت نہیں ملی۔ براؤزر میں اجازت دے کر دوبارہ ذریعہ چنیں۔`)
};

const fa_video_capture_denied = /** @type {(inputs: Video_Capture_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اجازهٔ ضبط داده نشد. در مرورگر اجازه دهید و دوباره منبعی برگزینید.`)
};

const sw_video_capture_denied = /** @type {(inputs: Video_Capture_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunasa hakukuruhusiwa. Ruhusu ufikiaji kwenye kivinjari kisha uchague chanzo tena.`)
};

const nl_video_capture_denied = /** @type {(inputs: Video_Capture_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opnemen is niet toegestaan. Geef toegang in de browser en kies opnieuw een bron.`)
};

/**
* | output |
* | --- |
* | "Capture was not allowed. Allow access in your browser, then choose a source again." |
*
* @param {Video_Capture_DeniedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_capture_denied = /** @type {((inputs?: Video_Capture_DeniedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Capture_DeniedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_capture_denied(inputs)
	if (locale === "ja") return ja_video_capture_denied(inputs)
	if (locale === "zh") return zh_video_capture_denied(inputs)
	if (locale === "es") return es_video_capture_denied(inputs)
	if (locale === "pt") return pt_video_capture_denied(inputs)
	if (locale === "id") return id_video_capture_denied(inputs)
	if (locale === "fr") return fr_video_capture_denied(inputs)
	if (locale === "tl") return tl_video_capture_denied(inputs)
	if (locale === "vi") return vi_video_capture_denied(inputs)
	if (locale === "ko") return ko_video_capture_denied(inputs)
	if (locale === "de") return de_video_capture_denied(inputs)
	if (locale === "ru") return ru_video_capture_denied(inputs)
	if (locale === "tr") return tr_video_capture_denied(inputs)
	if (locale === "it") return it_video_capture_denied(inputs)
	if (locale === "pl") return pl_video_capture_denied(inputs)
	if (locale === "uk") return uk_video_capture_denied(inputs)
	if (locale === "hi") return hi_video_capture_denied(inputs)
	if (locale === "ar") return ar_video_capture_denied(inputs)
	if (locale === "ms") return ms_video_capture_denied(inputs)
	if (locale === "bn") return bn_video_capture_denied(inputs)
	if (locale === "zh-TW") return zh_tw2_video_capture_denied(inputs)
	if (locale === "zh-HK") return zh_hk2_video_capture_denied(inputs)
	if (locale === "ur") return ur_video_capture_denied(inputs)
	if (locale === "fa") return fa_video_capture_denied(inputs)
	if (locale === "sw") return sw_video_capture_denied(inputs)
	if (locale === "nl") return nl_video_capture_denied(inputs)
	return en_video_capture_denied(inputs)
});